import { FETCH_PERSON_ROSTER_ROLE_DATA, SET_SELECTED } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

export const personRosterRoleReducer = reducer(FETCH_PERSON_ROSTER_ROLE_DATA);
export const selectedReducer = reducer(SET_SELECTED);
